import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute(
  "/app/admin-settings/automatic-background-jobs/new"
)({
  component: lazyImportRouteComponent(
    () => import("./-components/NewBackgroundJobDefinitionPage"),
    "NewBackgroundJobDefinitionPage"
  ),
  beforeLoad(ctx) {
    return {
      getTitle: () =>
        ctx.context.t && ctx.context.t("CreateNewAutomaticBackgroundJob"),
    }
  },
})
